import React from 'react';
import * as Styled from './styled';
import SmileIcon from 'assets/svg/happy.svg';
import { MortgageOfficeRecomendations } from 'utils/entities';
import { useLocale } from 'locale';

export const ReviewCard: React.FC<MortgageOfficeRecomendations> = ({ customerName, text, agentName }) => {
  const { t } = useLocale();
  return (
    <Styled.Wrapper>
      <Styled.TitleWrapper>
        <SmileIcon />
        <Styled.NameWrapper>
          <Styled.Title weight="bold">{customerName}</Styled.Title>
          {agentName ? <Styled.WorkedWith>{t('testimonials.work.with.agentName', { agentName })}</Styled.WorkedWith> : null}
        </Styled.NameWrapper>
      </Styled.TitleWrapper>
      <Styled.Description>{text}</Styled.Description>
    </Styled.Wrapper>
  );
};
